import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";

const API = localStorage.getItem("assethost");

export default class FileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      contentType: "",
      fileData: ""
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let flagId = urlParams.get("flagId");
    if (!flagId) {
      flagId = this.props.flagId;
    }
 
    if (flagId) {
      
      this.getFile(flagId)
    } else {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
    }
  }

  getFile(flagId) {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(
        API + `/asset/getpolicereportfile/${flagId}`,
       
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
          this.setState({
            contentType: response.data.contentType,
            fileData: response.data.fileData,
            loading: false,
          });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Recovery update failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Recovered" footerContent={<></>}>
          <div className="w-full h-10 overflow-hidden flex justify-center items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="File View"
        closeAction={this.props.closeAction}
        footerContent={
          <>
            <button
              type="button"
              className="btn btn-success"
              onClick={this.props.closeAction}
            >
              Close
            </button>
          </>
        }
      >
        {divMsg}
        <div className="row">
          <div className="col">
             { this.state.contentType === 'application/pdf' && <iframe title="File View" src={this.state.fileData} type="application/pdf" style={{ width: 100 + '%', height: 500 + 'px' }}></iframe> }
                           { this.state.contentType.includes('image') && <img title="File View" alt={this.state.contentType} src={'data:'+this.state.contentType+';base64,' + this.state.fileData}  style={{ width: 100 + '%' }} /> }
          </div>
        </div>
      </Modal>
    );
  }
}
